/* LX header / drawer v24（2026-10-09 Claude）: ドロワーの開閉だけ。開閉の中身は <details> で動く */
(function () {
  if (window.__lxHf2) return; window.__lxHf2 = true;
  function init() {
    var body = document.body, drawer = document.getElementById('lx-drawer');
    var overlay = document.querySelector('[data-lx-overlay]');
    function setOpen(open) {
      body.classList.toggle('lx-drawer-open', open);
      if (drawer) { drawer.setAttribute('aria-hidden', open ? 'false' : 'true'); if (open) { drawer.scrollTop = 0; } }
      document.querySelectorAll('.lx-menu-open').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    }
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : null; if (!t) return;
      if (t.closest('.lx-menu-open')) { e.preventDefault(); setOpen(true); return; }
      if (t.closest('.lx-menu-close') || t.closest('[data-lx-overlay]')) { e.preventDefault(); setOpen(false); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && body.classList.contains('lx-drawer-open')) setOpen(false); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
